<div *ngIf="structuredData">
    <div itemtype="http://schema.org/Product" itemscope>
        <meta itemprop="productID" content="{{product.id}}" />
        <meta itemprop="sku" content="{{structuredData.skuId}}" />
        <meta itemprop="name" content="{{structuredData.productName}}{{product.subText ? ' ' + product.subText : ''}}" />
        <link *ngIf="structuredData.productImage" itemprop="image" [href]="structuredData.productImage | safeHTML : 'resourceUrl' " />
        <meta itemprop="description" content="{{structuredData.productDescription}}" />
        <meta itemprop="category" content="503743" />
        <div itemprop="brand" itemtype="http://schema.org/Brand" itemscope>
            <meta itemprop="name" content="Yorkstone Supplies" />
        </div>

        <div itemprop="offers" itemscope itemtype="http://schema.org/Offer">
            <link itemprop="url" [href]="trustedUrl" />
            <meta itemprop="itemCondition" content="https://schema.org/NewCondition" />
            <meta itemprop="availability" content="https://schema.org/InStock" />
            <meta itemprop="price" content="{{structuredData.skuPrice}}" />
            <meta itemprop="priceCurrency" content="GBP" />
            <meta itemprop="priceValidUntil" content="{{structuredData.priceValidUntil}}" />
        </div>
    </div>
</div>
